import { styled } from 'styled-components';

import useUpdateUserInfo from '../hooks/useUpdateUserInfo';
import FormRow from 'components/FormRow';
import Input from 'components/ui/Input';
import Textarea from 'components/ui/Textarea';
import Button from 'components/ui/Button';

const Form = styled.form`
  display: flex;
  flex-direction: column;
  width: 100%;
  gap: 10px;
`;

const Container = styled.div``;

const Name = styled.h1`
  font-size: 32px;
  font-weight: 600;
`;

const Description = styled.p`
  margin-top: 10px;
  word-break: break-all;
`;

const EditBtn = styled.button`
  color: ${(props) => props.theme.global.mainColor};
  text-decoration: underline;
  text-underline-position: under;
  margin-top: 20px;
`;

const UserInfo = () => {
  const { user, isUpdateMode, useFormReturn, isLoading, onUpdateModeButtonClick, onValid } = useUpdateUserInfo();
  const {
    formState: { errors },
    register,
    handleSubmit,
  } = useFormReturn;

  if (isUpdateMode) {
    return (
      <Form onSubmit={handleSubmit(onValid)}>
        <FormRow error={errors?.userName?.message}>
          <Input {...register('userName')} />
        </FormRow>
        <FormRow error={errors?.description?.message}>
          <Textarea {...register('description')} height={80} />
        </FormRow>
        <div>
          <Button style={{ marginTop: '10px' }} disabled={isLoading}>
            저장하기
          </Button>
        </div>
      </Form>
    );
  }

  return (
    <Container>
      <Name>{user?.userName}</Name>
      <Description>{user?.description}</Description>
      <EditBtn onClick={onUpdateModeButtonClick}>수정하기</EditBtn>
    </Container>
  );
};

export default UserInfo;
